import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Header from '../../../client/Header';
import LoaderSpinner from '../../../shared/components/Loader';
import Footer from '../../../client/Footer';

import { getCurrentUser } from '../../../redux/auth/auth-operations';
import { routes } from './routes';

import PublicPage from '../PublicRoute';
import PrivatePage from '../PrivateRoute';
const AuthPage = lazy(() => import('../../../pages/AuthPage') /* webpackChunkName: "AuthPage" */);
const ContactsPage = lazy(() => import('../../../pages/ContactsPage') /* webpackChunkName: "ContactsPage" */);
const MainPage = lazy(() => import('../../../pages/MainPage') /* webpackChunkName: "MainPage" */);
const TestPage = lazy(() => import('../../../pages/TestPage') /* webpackChunkName: "TestPage" */);
const ResultsPage = lazy(() =>import('../../../pages/ResultsPage') /* webpackChunkName: "ResultsPage" */);
const UsefulInfoPage = lazy(() =>import('../../../pages/UsefulInfoPage') /* webpackChunkName: "UsefulInfoPage" */);

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  const { auth, contacts, main, test, results, materials } = routes;
  return (
    <Router>
      <Suspense fallback={<LoaderSpinner />}>
        <Header/>
        <Switch>
          <PublicPage exact path={auth} restricted component={AuthPage} redirectTo={main}/>
          <Route exact path={contacts} component={ContactsPage} />
          <PrivatePage exact path={main} component={MainPage} redirectTo={auth} />
          <PrivatePage exact path={test + '/:typeTest'} component={TestPage} redirectTo={auth} />
          <PrivatePage exact path={results} component={ResultsPage} redirectTo={auth} />
          <PrivatePage exact path={materials} component={UsefulInfoPage} redirectTo={auth} />
        </Switch>
        <Footer />
      </Suspense>
    </Router>
  );
}

export default App;
